export const MAX_ATTEMPTS = 2;
export const COUNTDOWN_DURATION = 120; // 2 minutes
export const STORAGE_KEY = 'verification_attempts';